import Swiper from "swiper"
import { Navigation } from "swiper/modules"
import { getElements } from "@oddcamp/js-utils/src/selector"

import init from "../../shared/utils/init"

// swiper

init(() => {
  getElements(`.cards-carousel`).forEach((containerEl) => {
    new Swiper(containerEl.querySelector(`.swiper`), {
      modules: [Navigation],
      slidesPerView: `auto`,
      navigation: {
        nextEl: containerEl.querySelector(`.swiper-button-next`),
        prevEl: containerEl.querySelector(`.swiper-button-prev`),
      },
    })
  })
})
